export default "__VITE_ASSET__DDCGA8qr__"